if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.setupMobileFloatingButton();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        let preorderData = {};
        try {
          const quantityToStart = this.form.closest('.product__info-container')?.querySelector('.quantity__input')?.getAttribute('quantity-to-start');
          if(quantityToStart && parseInt(formData.get('quantity')) > parseInt(quantityToStart)){
            preorderData = {
              id: formData.get('id'),
              quantity: parseInt(formData.get('quantity')) - parseInt(quantityToStart),
              properties: {
                _is_preorder: this.form.getAttribute('preorder-props'),
                _preorder_locale: Shopify.locale
              }
            }
            formData.set('quantity', parseInt(quantityToStart));
          }
        } catch (error) {}
        config.body = formData;

        //封装加购参数
        let product_list = [];
        const product_form_dom = document.querySelector(
          ".complementary-products"
        );
        console.log("acc-comp:",product_form_dom)
        if (product_form_dom) {
          const product_items =
            product_form_dom.querySelectorAll(".checkmark[data-clicked='true']");
          console.log("acc-check:",product_items)
          product_items?.forEach((item) => {
              product_list.push(item.getAttribute("data-product-id"));
          });
        }
        console.log("product-list:",product_list)
        const data = {
          items: [],
          sections:this.cart.getSectionsToRender().map((section) => section.id)
        };

        if (product_list.length > 0) {
          product_list.forEach((item) => {
            data.items.push({
              id: item,
              quantity: 1,
            });
          });
          await fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            document.dispatchEvent(new CustomEvent('globo.theme.cart.added', { detail: { preorderData: preorderData } }));
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.submitButtonText.textContent += document.querySelector('.price-item.price-item--regular').textContent || ''
        }
      }

      setupMobileFloatingButton() {
        const removeWrapperTransform = () => {
          const wrapperEl = this.closest('.product__info-wrapper');
          if (!wrapperEl) return;

          // Remove all transform and animation to avoid position "fixed" not work
          wrapperEl.style.transform = "none";
          wrapperEl.style.animation = "none";
          wrapperEl.style.transition = "none";
          wrapperEl.style.opacity = 1;
        }

        const floatSubmitButton = () => {
          if (window.innerWidth > 749) return;

          removeWrapperTransform();

          this.querySelectorAll('.product-form__submit:not(.hidden, .gPreorderHidden)').forEach((el) => {
            el.classList.add('floating');
          })
        }

        const unfloatSubmitButton = () => {
          this.querySelectorAll('.product-form__submit.floating').forEach((el) => {
            el.classList.remove('floating');
          })
        }

        window.addEventListener('scroll', () => {
          const rect = this.getBoundingClientRect();

          if (rect.top <= window.innerHeight) {
            floatSubmitButton();
          } else {
            unfloatSubmitButton();
          }
        })
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
